import type { Plan } from 'types/plan'
import api from 'lib/api'

export function fetchAll() {
  return api
    .get<{ data: Plan[] }>('/api/v2/plans')
    .then(({ data }) => data.data)
}
